"use client";

import Link from "next/link";
import type { ComponentProps, MouseEvent, ReactNode } from "react";

import { getCtaDataAttrs } from "@/lib/analytics/cta-attrs";

type Props = Omit<ComponentProps<typeof Link>, "onClick"> & {
	ctaId: string;
	ctaName: string;
	ctaLocation: string;
	children: ReactNode;
	onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Link that stamps `data-cta-*` attrs. The global `CtaClickTracker` fires
 * `cta_click` — keep wrappers thin so we don't double-count.
 */
export default function TrackedCtaLink({
	ctaId,
	ctaName,
	ctaLocation,
	href,
	children,
	onClick,
	...rest
}: Props) {
	const linkUrl = typeof href === "string" ? href : undefined;

	return (
		<Link
			href={href}
			{...rest}
			{...getCtaDataAttrs({ ctaId, ctaName, ctaLocation, linkUrl })}
			onClick={onClick}
		>
			{children}
		</Link>
	);
}
